import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import LinearProgress from "@mui/material/LinearProgress";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import DauTrang, { NhanDau } from "components/DauTrang";
import { cmSangPx, layKichThuocQrMacDinhCm, luuKichThuocQrMacDinhCm } from "lib/caiDat";
import { quyTacMaChuVuonApi } from "api/quyTacMaChuVuon";
import { chuVuonApi } from "api/chuVuon";
import { diaChiApi } from "api/diaChi";
import { giaBoWebsiteApi, GIA_BO_PUSH_URL_MAC_DINH, urlKeoGiaCongKhai } from "api/giaBoWebsite";
import { QUY_TAC_MAC_DINH, apDungMauMa, kiemTraTruongSinhMa, khoaBoDem } from "lib/quyTacMaChuVuon";
import { coPepperCccd } from "lib/cccdBaoMat";
import useTour from "hooks/useTour";
import buocCaiDat from "tours/caiDat";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

function CaiDat() {
  const pepperSanSang = coPepperCccd();
  const [kichThuocQrCm, setKichThuocQrCm] = useState(layKichThuocQrMacDinhCm);
  const [daLuu, setDaLuu] = useState(false);

  function luu(e) {
    e.preventDefault();
    luuKichThuocQrMacDinhCm(Number(kichThuocQrCm) || 4);
    setDaLuu(true);
    setTimeout(() => setDaLuu(false), 2000);
  }

  const px = cmSangPx(kichThuocQrCm || 1);

  const [quyTac, setQuyTac] = useState(QUY_TAC_MAC_DINH);
  const [dangTaiQuyTac, setDangTaiQuyTac] = useState(true);
  const [dangLuuQuyTac, setDangLuuQuyTac] = useState(false);
  const [daLuuQuyTac, setDaLuuQuyTac] = useState(false);
  const [loiQuyTac, setLoiQuyTac] = useState("");

  const [dangTaoLaiMa, setDangTaoLaiMa] = useState(false);
  const [ketQuaTaoLaiMa, setKetQuaTaoLaiMa] = useState("");
  const [loiTaoLaiMa, setLoiTaoLaiMa] = useState("");

  const [dangMaHoaCccd, setDangMaHoaCccd] = useState(false);
  const [tienDoCccd, setTienDoCccd] = useState(null);
  const [ketQuaCccd, setKetQuaCccd] = useState(null);
  const [loiCccd, setLoiCccd] = useState("");

  const [wpPushUrl, setWpPushUrl] = useState(GIA_BO_PUSH_URL_MAC_DINH);
  const [wpSecret, setWpSecret] = useState("");
  const [wpTuDongDay, setWpTuDongDay] = useState(true);
  const [wpPullUrl, setWpPullUrl] = useState(urlKeoGiaCongKhai);
  const [hienSecret, setHienSecret] = useState(false);
  const [dangTaiWp, setDangTaiWp] = useState(true);
  const [dangLuuWp, setDangLuuWp] = useState(false);
  const [dangKiemTraWp, setDangKiemTraWp] = useState(false);
  const [dangXuatBanWp, setDangXuatBanWp] = useState(false);
  const [daLuuWp, setDaLuuWp] = useState(false);
  const [loiWp, setLoiWp] = useState("");
  const [thongBaoWp, setThongBaoWp] = useState("");
  const [lanDayCuoiWp, setLanDayCuoiWp] = useState(null);

  useEffect(() => {
    quyTacMaChuVuonApi
      .layQuyTac()
      .then(setQuyTac)
      .finally(() => setDangTaiQuyTac(false));
  }, []);

  useEffect(() => {
    setDangTaiWp(true);
    giaBoWebsiteApi
      .layCauHinh()
      .then((cfg) => {
        setWpPushUrl(cfg.pushUrl || GIA_BO_PUSH_URL_MAC_DINH);
        setWpSecret(cfg.secret || "");
        setWpTuDongDay(cfg.tuDongDay !== false);
        setWpPullUrl(cfg.pullUrl || urlKeoGiaCongKhai());
        setLanDayCuoiWp(cfg.lanDayCuoi || null);
      })
      .catch((err) => setLoiWp(err.message))
      .finally(() => setDangTaiWp(false));
  }, []);

  async function luuCauHinhWp(e) {
    e.preventDefault();
    setDangLuuWp(true);
    setLoiWp("");
    setThongBaoWp("");
    try {
      const data = await giaBoWebsiteApi.luuCauHinh({
        pushUrl: wpPushUrl,
        secret: wpSecret,
        tuDongDay: wpTuDongDay,
      });
      setWpPushUrl(data.pushUrl);
      setWpSecret(data.secret);
      setWpTuDongDay(data.tuDongDay);
      setWpPullUrl(data.pullUrl || urlKeoGiaCongKhai());
      setDaLuuWp(true);
      setThongBaoWp("Đã lưu cấu hình đồng bộ giá website.");
      setTimeout(() => setDaLuuWp(false), 2500);
    } catch (err) {
      setLoiWp(err.message);
    } finally {
      setDangLuuWp(false);
    }
  }

  async function kiemTraWp() {
    setDangKiemTraWp(true);
    setLoiWp("");
    setThongBaoWp("");
    try {
      const body = await giaBoWebsiteApi.kiemTraHealth(wpPushUrl);
      setThongBaoWp(`Plugin sống — ${body.plugin || "gia-bo"} v${body.version || "?"}.`);
    } catch (err) {
      setLoiWp(err.message);
    } finally {
      setDangKiemTraWp(false);
    }
  }

  async function xuatBanCongKhaiWp() {
    setDangXuatBanWp(true);
    setLoiWp("");
    setThongBaoWp("");
    try {
      // Tạo URL công khai (hết 404) + đẩy WP nếu đã có secret.
      const homNay = new Date();
      const p = (n) => String(n).padStart(2, "0");
      const ngay = `${homNay.getFullYear()}-${p(homNay.getMonth() + 1)}-${p(homNay.getDate())}`;
      const ketQua = await giaBoWebsiteApi.dayGiaLenWebsite({
        ngay,
        cauHinh: { pushUrl: wpPushUrl, secret: wpSecret, tuDongDay: wpTuDongDay },
      });
      if (ketQua.pullUrl) setWpPullUrl(ketQua.pullUrl);
      setThongBaoWp(ketQua.message || "Đã đồng bộ.");
      setLanDayCuoiWp(ketQua.lanDayCuoi || null);
    } catch (err) {
      setLoiWp(err.message);
    } finally {
      setDangXuatBanWp(false);
    }
  }

  async function saoChepPullUrl() {
    try {
      await navigator.clipboard.writeText(wpPullUrl);
      setThongBaoWp("Đã copy URL kéo giá — dán vào WP Admin → Kết nối API → URL API kéo giá.");
    } catch {
      setLoiWp("Không copy được — hãy chọn và copy URL thủ công.");
    }
  }

  async function luuQuyTac(e) {
    e.preventDefault();
    setDangLuuQuyTac(true);
    setLoiQuyTac("");
    try {
      await quyTacMaChuVuonApi.luuQuyTac(quyTac);
      setDaLuuQuyTac(true);
      setTimeout(() => setDaLuuQuyTac(false), 2000);
    } catch (err) {
      setLoiQuyTac(err.message);
    } finally {
      setDangLuuQuyTac(false);
    }
  }

  async function taoLaiMaHangLoat() {
    // eslint-disable-next-line no-alert
    const xacNhan = window.confirm(
      "Tạo lại mã cho TOÀN BỘ chủ vườn hiện có theo quy tắc mới?\n\n" +
        "Mã QR đã in dán ngoài thực địa sẽ KHÔNG còn khớp với mã hiển thị trong hệ thống " +
        "sau khi đổi — chỉ làm khi chắc chắn sẽ in lại toàn bộ mã QR chủ vườn.\n\n" +
        "Thao tác này không thể tự động hoàn tác."
    );
    if (!xacNhan) return;

    setDangTaoLaiMa(true);
    setLoiTaoLaiMa("");
    setKetQuaTaoLaiMa("");
    try {
      const quyTacHienHanh = await quyTacMaChuVuonApi.layQuyTac();
      const danhSach = await chuVuonApi.danhSachTatCa();

      const tinhList = await diaChiApi.danhSachTinh();
      const xaCacheTheoTinh = {};
      async function layXaMa(tenTinh, tenXa) {
        const tinhObj = tinhList.find((t) => t.name === tenTinh);
        if (!tinhObj) return { tinhMa: "", xaMa: "" };
        if (!xaCacheTheoTinh[tinhObj.code]) {
          xaCacheTheoTinh[tinhObj.code] = await diaChiApi.danhSachXa(tinhObj.code);
        }
        const xaObj = xaCacheTheoTinh[tinhObj.code].find((x) => x.name === tenXa);
        return { tinhMa: tinhObj.code, xaMa: xaObj?.code ?? "" };
      }

      // Gán mã theo đúng thứ tự tạo trước/sau để STT không bị đảo lộn.
      const daSapXep = [...danhSach].sort((a, b) =>
        (a.createdAt ?? "") < (b.createdAt ?? "") ? -1 : 1
      );

      const boDemTrongBoNho = {};
      let soDaCapNhat = 0;
      const boQua = [];

      for (const cv of daSapXep) {
        let { tinhMa, xaMa } = cv;
        if (!tinhMa || !xaMa) {
          const tra = await layXaMa(cv.tinh, cv.xa);
          tinhMa = tra.tinhMa;
          xaMa = tra.xaMa;
        }
        const loaiChuVuon = cv.loaiChuVuon || "thuong";
        const mau =
          loaiChuVuon === "nhan_vien" ? quyTacHienHanh.mauNhanVien : quyTacHienHanh.mauThuong;
        try {
          kiemTraTruongSinhMa(mau, { tinhMa, xaMa });
        } catch {
          boQua.push(cv.maChuVuon || cv.cccd || cv.hoTen || cv.id);
          continue;
        }
        const khoa = khoaBoDem({ loaiChuVuon, tinhMa, xaMa });
        const stt = (boDemTrongBoNho[khoa] ?? 0) + 1;
        boDemTrongBoNho[khoa] = stt;

        const maChuVuonMoi = apDungMauMa(mau, {
          tinh: tinhMa,
          xa: xaMa,
          stt,
          soChuSoStt: quyTacHienHanh.soChuSoStt,
        });

        await chuVuonApi.capNhat(cv.id, { maChuVuon: maChuVuonMoi, tinhMa, xaMa });
        soDaCapNhat += 1;
      }

      await Promise.all(
        Object.entries(boDemTrongBoNho).map(([khoa, gtri]) =>
          quyTacMaChuVuonApi.datBoDem(khoa, gtri)
        )
      );

      setKetQuaTaoLaiMa(
        boQua.length > 0
          ? `Đã tạo lại mã cho ${soDaCapNhat} chủ vườn. Bỏ qua ${
              boQua.length
            } hồ sơ thiếu Tỉnh/Xã (không sinh LV-XX-XX): ${boQua.join(", ")}.`
          : `Đã tạo lại mã cho ${soDaCapNhat} chủ vườn.`
      );
    } catch (err) {
      setLoiTaoLaiMa(err.message);
    } finally {
      setDangTaoLaiMa(false);
    }
  }

  async function maHoaCccdDaLuu() {
    if (!coPepperCccd()) {
      setLoiCccd(
        "Thiếu REACT_APP_CCCD_PEPPER trong bundle hiện tại. Thêm vào frontend/.env, rồi restart npm start (local) hoặc build+deploy hosting (web.app). Hard refresh (Ctrl+F5) sau khi deploy."
      );
      return;
    }
    // eslint-disable-next-line no-alert
    const xacNhan = window.confirm(
      "Mã hóa CCCD đã lưu trên toàn bộ chủ vườn?\n\n" +
        "• Pepper đã có trong bundle hiện tại.\n" +
        "• Deploy firestore.rules TRƯỚC khi chạy.\n" +
        "• Giữ số CCCD đủ (cần bảng kê thuế Biểu 01).\n" +
        "• Thêm hash + mask; đổi doc id nếu id đang là số CCCD.\n\n" +
        "Có thể chạy lại nếu còn hồ sơ legacy."
    );
    if (!xacNhan) return;

    setDangMaHoaCccd(true);
    setLoiCccd("");
    setKetQuaCccd(null);
    setTienDoCccd({ daXuLy: 0, tong: 0 });
    try {
      const ketQua = await chuVuonApi.migrateCccdBaoMat({
        onProgress: (p) => setTienDoCccd(p),
      });
      setKetQuaCccd(ketQua);
      setTienDoCccd(null);
      if (ketQua.loi > 0 && ketQua.chiTietLoi?.length) {
        const mau = ketQua.chiTietLoi
          .slice(0, 5)
          .map((x) => `${x.id}: ${x.lyDo}`)
          .join("; ");
        setLoiCccd(
          `Hoàn tất với ${ketQua.loi} lỗi. Ví dụ: ${mau}${ketQua.chiTietLoi.length > 5 ? "…" : ""}`
        );
      }
    } catch (err) {
      setLoiCccd(err.message || String(err));
      setTienDoCccd(null);
    } finally {
      setDangMaHoaCccd(false);
    }
  }

  useTour("cai-dat", buocCaiDat());

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <DauTrang
          nhan="Hệ thống"
          tieuDe="Cài đặt"
          moTa="Kích thước tem QR áp dụng cho máy/trình duyệt đang dùng; quy tắc sinh mã áp dụng cho cả hệ thống."
        />

        <Grid container justifyContent="center" spacing={3}>
          <Grid item xs={12}>
            <Card id="tour-cai-dat-gia-bo-website">
              <MDBox p={2.5} component="form" onSubmit={luuCauHinhWp}>
                <NhanDau>Website</NhanDau>
                <MDTypography variant="h6" mb={0.5}>
                  Báo giá WordPress
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  mb={2}
                  display="block"
                >
                  Cách chắc chắn nhất: dán <strong>X-Gia-Bo-Secret</strong> từ WP →{" "}
                  <strong>Lưu cấu hình</strong> → <strong>Đồng bộ ngay lên website</strong> (app đẩy
                  thẳng vào web). URL kéo phía dưới chỉ dùng nếu WP bật Sync/cron kéo về.
                </MDTypography>

                {dangTaiWp ? (
                  <MDTypography variant="button" color="text">
                    Đang tải cấu hình...
                  </MDTypography>
                ) : (
                  <>
                    {loiWp && (
                      <MDBox mb={2}>
                        <MDAlert color="error">{loiWp}</MDAlert>
                      </MDBox>
                    )}
                    {(thongBaoWp || daLuuWp) && (
                      <MDBox mb={2}>
                        <MDAlert color="success">{thongBaoWp || "Đã lưu."}</MDAlert>
                      </MDBox>
                    )}
                    {lanDayCuoiWp?.luc && (
                      <MDBox mb={2}>
                        <MDTypography variant="caption" color="text">
                          Lần đồng bộ gần nhất: {new Date(lanDayCuoiWp.luc).toLocaleString("vi-VN")}
                          {lanDayCuoiWp.ngay ? ` · ngày ${lanDayCuoiWp.ngay}` : ""}
                          {lanDayCuoiWp.message ? ` — ${lanDayCuoiWp.message}` : ""}
                        </MDTypography>
                      </MDBox>
                    )}

                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <MDBox display="flex" alignItems="flex-start" gap={0.5}>
                          <MDInput
                            label="URL API kéo giá (dán sang WordPress)"
                            value={wpPullUrl}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                          />
                          <IconButton
                            onClick={saoChepPullUrl}
                            sx={{ mt: 0.5 }}
                            aria-label="Copy URL kéo giá"
                            title="Copy"
                          >
                            <Icon>content_copy</Icon>
                          </IconButton>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12}>
                        <MDInput
                          label="POST URL (tuỳ chọn — app đẩy sang WP)"
                          value={wpPushUrl}
                          onChange={(e) => setWpPushUrl(e.target.value)}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          placeholder={GIA_BO_PUSH_URL_MAC_DINH}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MDBox display="flex" alignItems="flex-start" gap={0.5}>
                          <MDInput
                            type={hienSecret ? "text" : "password"}
                            label="X-Gia-Bo-Secret (tuỳ chọn)"
                            value={wpSecret}
                            onChange={(e) => setWpSecret(e.target.value)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            autoComplete="off"
                          />
                          <IconButton
                            onClick={() => setHienSecret((v) => !v)}
                            sx={{ mt: 0.5 }}
                            aria-label={hienSecret ? "Ẩn secret" : "Hiện secret"}
                          >
                            <Icon>{hienSecret ? "visibility_off" : "visibility"}</Icon>
                          </IconButton>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={wpTuDongDay}
                              onChange={(e) => setWpTuDongDay(e.target.checked)}
                            />
                          }
                          label="Tự xuất bản / đồng bộ sau mỗi lần lưu giá (Admin / Ban giám đốc)"
                        />
                      </Grid>
                    </Grid>

                    <MDBox display="flex" flexWrap="wrap" gap={1} mt={2}>
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        disabled={dangLuuWp || dangKiemTraWp || dangXuatBanWp}
                      >
                        {dangLuuWp ? "Đang lưu..." : "Lưu cấu hình"}
                      </MDButton>
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        disabled={dangLuuWp || dangKiemTraWp || dangXuatBanWp}
                        onClick={xuatBanCongKhaiWp}
                      >
                        {dangXuatBanWp ? "Đang đồng bộ..." : "Đồng bộ ngay lên website"}
                      </MDButton>
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="dark"
                        disabled={dangLuuWp || dangKiemTraWp || dangXuatBanWp}
                        onClick={kiemTraWp}
                      >
                        {dangKiemTraWp ? "Đang kiểm tra..." : "Kiểm tra WP health"}
                      </MDButton>
                    </MDBox>
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card id="tour-cai-dat-qr" sx={{ height: "100%" }}>
              <MDBox p={2.5} component="form" onSubmit={luu}>
                <NhanDau>Máy này</NhanDau>
                <MDTypography variant="h6" mb={0.5}>
                  Kích thước QR khi tải xuống
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  mb={2}
                  display="block"
                >
                  Dùng làm mặc định cho nút &quot;Tải xuống PNG&quot; ở QR Sọt và QR mã chủ vườn.
                  Ảnh QR luôn là hình vuông, số nhập vào là kích thước thật (cả chiều rộng lẫn chiều
                  cao) khi in ra giấy dán — ví dụ nhập <strong>4</strong> nghĩa là in ra tem{" "}
                  <strong>4 × 4 cm</strong>. Hệ thống tự quy đổi sang ảnh {px} × {px} px theo chuẩn
                  in 300dpi.
                </MDTypography>

                <MDBox width="12rem" mb={2}>
                  <MDInput
                    type="number"
                    label="Kích thước (cm)"
                    value={kichThuocQrCm}
                    onChange={(e) => setKichThuocQrCm(e.target.value)}
                    inputProps={{ min: 1, max: 20, step: 0.5 }}
                    fullWidth
                  />
                </MDBox>

                {daLuu && (
                  <MDBox mb={2}>
                    <MDAlert color="success">Đã lưu.</MDAlert>
                  </MDBox>
                )}

                <MDButton type="submit" variant="gradient" color="info">
                  Lưu
                </MDButton>
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card id="tour-cai-dat-quy-tac" sx={{ height: "100%" }}>
              <MDBox p={2.5} component="form" onSubmit={luuQuyTac}>
                <NhanDau>Toàn hệ thống</NhanDau>
                <MDTypography variant="h6" mb={0.5}>
                  Quy tắc sinh mã chủ vườn
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  mb={2}
                  display="block"
                >
                  Đặt mẫu riêng cho từng loại chủ vườn (chọn khi tạo chủ vườn ở form). Placeholder
                  dùng được: <strong>{"{tinh}"}</strong> (mã tỉnh), <strong>{"{xa}"}</strong> (mã
                  xã), <strong>{"{stt}"}</strong> (số thứ tự tự tăng, đếm riêng theo Tỉnh+Xã đối với
                  chủ vườn thường và đếm riêng cho nhân viên nội bộ). Nếu mẫu có{" "}
                  <strong>{"{tinh}"}</strong> hoặc <strong>{"{xa}"}</strong> thì lúc tạo chủ vườn
                  phải chọn đủ Tỉnh/Xã — không còn sinh mã kiểu LV-XX-XX-001.
                </MDTypography>

                {loiQuyTac && (
                  <MDBox mb={2}>
                    <MDAlert color="error">{loiQuyTac}</MDAlert>
                  </MDBox>
                )}

                <MDBox mb={2}>
                  <MDInput
                    label="Mẫu mã — Chủ vườn thường"
                    value={quyTac.mauThuong}
                    onChange={(e) => setQuyTac({ ...quyTac, mauThuong: e.target.value })}
                    fullWidth
                    disabled={dangTaiQuyTac}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    label="Mẫu mã — Nhân viên nội bộ"
                    value={quyTac.mauNhanVien}
                    onChange={(e) => setQuyTac({ ...quyTac, mauNhanVien: e.target.value })}
                    fullWidth
                    disabled={dangTaiQuyTac}
                  />
                </MDBox>
                <MDBox width="12rem" mb={2}>
                  <MDInput
                    type="number"
                    label="Số chữ số STT"
                    value={quyTac.soChuSoStt}
                    onChange={(e) => setQuyTac({ ...quyTac, soChuSoStt: Number(e.target.value) })}
                    inputProps={{ min: 1, max: 8, step: 1 }}
                    fullWidth
                    disabled={dangTaiQuyTac}
                  />
                </MDBox>

                {daLuuQuyTac && (
                  <MDBox mb={2}>
                    <MDAlert color="success">Đã lưu quy tắc.</MDAlert>
                  </MDBox>
                )}

                <MDButton
                  type="submit"
                  variant="gradient"
                  color="info"
                  disabled={dangTaiQuyTac || dangLuuQuyTac}
                >
                  {dangLuuQuyTac ? "Đang lưu..." : "Lưu quy tắc"}
                </MDButton>

                <Divider sx={{ mt: 3, mb: 2 }} />

                <MDBox display="flex" alignItems="center" gap={1} mb={0.5}>
                  <MDBox
                    sx={({ palette }) => ({
                      width: 22,
                      height: 2,
                      borderRadius: 1,
                      backgroundColor: palette.error.main,
                    })}
                  />
                  <MDTypography variant="overline" color="error" lineHeight={1}>
                    Vùng nguy hiểm
                  </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" mb={2} display="block">
                  Áp dụng quy tắc hiện hành để đặt lại mã cho toàn bộ chủ vườn đã có (kể cả những
                  người đã có mã từ trước). QR đã in trước đó sẽ không còn khớp mã hiển thị.
                </MDTypography>

                {loiTaoLaiMa && (
                  <MDBox mb={2}>
                    <MDAlert color="error">{loiTaoLaiMa}</MDAlert>
                  </MDBox>
                )}
                {ketQuaTaoLaiMa && (
                  <MDBox mb={2}>
                    <MDAlert color="success">{ketQuaTaoLaiMa}</MDAlert>
                  </MDBox>
                )}

                <MDButton
                  id="tour-cai-dat-nguy-hiem"
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={taoLaiMaHangLoat}
                  disabled={dangTaoLaiMa || dangMaHoaCccd}
                >
                  {dangTaoLaiMa ? "Đang tạo lại mã..." : "Tạo lại mã cho toàn bộ chủ vườn"}
                </MDButton>

                <Divider sx={{ mt: 3, mb: 2 }} />

                <MDBox display="flex" alignItems="center" gap={1} mb={0.5}>
                  <MDBox
                    sx={({ palette }) => ({
                      width: 22,
                      height: 2,
                      borderRadius: 1,
                      backgroundColor: palette.error.main,
                    })}
                  />
                  <MDTypography variant="overline" color="error" lineHeight={1}>
                    Bảo mật CCCD
                  </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" mb={2} display="block">
                  Cần <strong>REACT_APP_CCCD_PEPPER</strong> trong frontend/.env (không commit giá
                  trị thật). Deploy rules trước khi chạy. Số CCCD đủ vẫn lưu để bảng kê thuế; nhân
                  viên chỉ thấy dạng che. Tìm kiếm vẫn nhập CCCD đầy đủ.
                </MDTypography>
                <MDBox mb={2}>
                  <MDAlert color={pepperSanSang ? "success" : "error"}>
                    {pepperSanSang
                      ? "Pepper đã sẵn sàng trong bản app đang chạy — có thể mã hóa."
                      : "Pepper chưa có trong bản app đang chạy. Thêm REACT_APP_CCCD_PEPPER vào .env → restart npm start hoặc build+deploy → Ctrl+F5."}
                  </MDAlert>
                </MDBox>

                {loiCccd && (
                  <MDBox mb={2}>
                    <MDAlert color="error">{loiCccd}</MDAlert>
                  </MDBox>
                )}
                {ketQuaCccd && (
                  <MDBox mb={2}>
                    <MDAlert color={ketQuaCccd.loi > 0 ? "warning" : "success"}>
                      Tổng {ketQuaCccd.tong} · Đã hash {ketQuaCccd.capNhatTaiCho} · Đổi ID{" "}
                      {ketQuaCccd.rewriteId} · Bỏ qua {ketQuaCccd.boQua} · Lỗi {ketQuaCccd.loi}
                    </MDAlert>
                  </MDBox>
                )}
                {tienDoCccd && tienDoCccd.tong > 0 && (
                  <MDBox mb={2}>
                    <MDTypography variant="caption" color="text" display="block" mb={0.5}>
                      Đang xử lý {tienDoCccd.daXuLy}/{tienDoCccd.tong}
                      {tienDoCccd.loi > 0 ? ` · lỗi ${tienDoCccd.loi}` : ""}
                    </MDTypography>
                    <LinearProgress
                      variant="determinate"
                      value={Math.min(100, (100 * tienDoCccd.daXuLy) / tienDoCccd.tong)}
                      color="error"
                    />
                  </MDBox>
                )}
                {dangMaHoaCccd && (!tienDoCccd || !tienDoCccd.tong) && (
                  <MDBox mb={2}>
                    <LinearProgress color="error" />
                  </MDBox>
                )}

                <MDButton
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={maHoaCccdDaLuu}
                  disabled={dangMaHoaCccd || dangTaoLaiMa || !pepperSanSang}
                >
                  {dangMaHoaCccd ? "Đang mã hóa CCCD..." : "Mã hóa CCCD đã lưu"}
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CaiDat;
